export const PROGRAMMER_PROFESSIONS = ['Frontend Developer', 'Fullstack Developer', 'Backend Developer']
export const TESTER_PROFESSIONS = ['Tester']

export const PROFESSION_FILTERS = {
  'Frontend Developer': ['Frontend Developer', 'Fullstack Developer'],
  'Fullstack Developer': ['Fullstack Developer', 'Frontend Developer', 'Backend Developer'],
  'Backend Developer': ['Backend Developer', 'Fullstack Developer']
}
